import objectFitImages from 'object-fit-images';
import picturefill from 'picturefill';
picturefill();
objectFitImages('img', {watchMQ: true});